import Container from './Container';
import Overlay from './Overlay';

class Survey {
  private messageListener: ((event: MessageEvent) => void) | null = null;
  private resizeListener: (() => void) | null = null;
  private lastPositionData: {
    position: string;
    dimensions: { width: number; height: number };
    hasBackdrop: boolean;
  } | null = null;

  constructor() {
    this.startListeners();
  }

  private calculateIframePosition(
    position: string,
    dimensions: { width: number; height: number }
  ): { top: string; left: string } {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const padding = 20;

    let top: string;
    let left: string;

    switch (position) {
      case 'top-left':
        top = `${padding}px`;
        left = `${padding}px`;
        break;
      case 'top-right':
        top = `${padding}px`;
        left = `${viewportWidth - dimensions.width - padding}px`;
        break;
      case 'bottom-left':
        top = `${viewportHeight - dimensions.height - padding}px`;
        left = `${padding}px`;
        break;
      case 'bottom-right':
        top = `${viewportHeight - dimensions.height - padding}px`;
        left = `${viewportWidth - dimensions.width - padding}px`;
        break;
      case 'top-center':
        top = `${padding}px`;
        left = `${(viewportWidth - dimensions.width) / 2}px`;
        break;
      case 'bottom-center':
        top = `${viewportHeight - dimensions.height - padding}px`;
        left = `${(viewportWidth - dimensions.width) / 2}px`;
        break;
      case 'center':
        top = `${(viewportHeight - dimensions.height) / 2}px`;
        left = `${(viewportWidth - dimensions.width) / 2}px`;
        break;
      default:
        top = `${viewportHeight - dimensions.height - padding}px`;
        left = `${viewportWidth - dimensions.width - padding}px`;
    }

    return { top, left };
  }

  private handleResize = () => {
    if (this.lastPositionData) {
      const calculatedPosition = this.calculateIframePosition(
        this.lastPositionData.position,
        this.lastPositionData.dimensions
      );

      Container.getInstance().resizeAndPosition(calculatedPosition, {
        width: `${this.lastPositionData.dimensions.width}px`,
        height: `${this.lastPositionData.dimensions.height}px`
      });

      if (this.lastPositionData.hasBackdrop) {
        Overlay.getInstance().show();
      } else {
        Overlay.getInstance().hide();
      }
    }
  };

  private startListeners() {
    Container.getInstance().sendMessage({
      type: 'RUNNING_SURVEY'
    });

    this.messageListener = async (event: MessageEvent) => {
      if (event.data.type === 'RESIZE_AND_POSITION_IFRAME') {
        const { position, dimensions, hasBackdrop } = event.data;

        this.lastPositionData = { position, dimensions, hasBackdrop };

        const calculatedPosition = this.calculateIframePosition(position, dimensions);

        Container.getInstance().resizeAndPosition(calculatedPosition, {
          width: `${dimensions.width}px`,
          height: `${dimensions.height}px`
        });

        Container.getInstance().show();

        if (hasBackdrop) {
          Overlay.getInstance().show();
        } else {
          Overlay.getInstance().hide();
        }
      }
    };

    this.resizeListener = this.handleResize;

    window.addEventListener('message', this.messageListener);
    window.addEventListener('resize', this.resizeListener);
  }

  public destroy(): void {
    if (this.messageListener) {
      window.removeEventListener('message', this.messageListener);
      this.messageListener = null;
    }

    if (this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener);
      this.resizeListener = null;
    }

    this.lastPositionData = null;
  }
}

export default Survey;
